OT.createNS('OT.BestAnalytics');

// TODO: Handle window resize event, track page height, restaurant start and end positions
OT.BestAnalytics = (function() {
  var $window = $(window);
  var ridsSeenThisPageView = [];
  var $list, $parent, listHeight, itemCount, heightPerItem, listTop;

  // Execute the initialize function when page loads
  // TODO: Should this be called externally? helps testability.
  $(initialize);

  function initialize() {
    attachScrollListener();
    attachWindowUnload();
    attachRestaurantLoadEvent();
    onRestaurantListChange();
  }

  /**
   * Called when page loads to query DOM and calculate restaurant items
   */
  function onRestaurantListChange() {
    logViewport(true); // Asynchronous, done during normal page lifetime
    $list = $('#search_results .infinite-results-list').not('.exact-match');
    $parent = $window;

    if (!$list.length) {
      $list = $('.infinite-results-list').not('.exact-match');
      $parent = $('.map-results-scroll-container');
      $parent.scroll(_.debounce(onResultsScroll, 250));
    }

    if ($list.length) {
      listHeight = $list.height();

      itemCount = $list.find('> .result').length;
      heightPerItem = listHeight / itemCount;

      listTop = $list.offset().top;

      onResultsScroll();
    }
  }

  /**
   * Called when page loads to add a scroll event listener
   */
  function attachScrollListener() {
    OT.Events.on('scroll:stop', onResultsScroll);
  }

  /**
   * Called when page loads to add a page unload event listener
   */
  function attachWindowUnload() {
    $window.unload(function() {
      logViewport(false); // Synchronous, done during page teardown
    });
  }

  /**
   * When results are done loading we need to recalculate their positions
   */
  function attachRestaurantLoadEvent() {
    OT.Events.on('results:done', onRestaurantListChange);
  }

  /**
   * Called after scrolling through restaurants
   * Assumes each entry in list is same height for efficiency, e.g. item 11/100 is 11% high
   */
  function onResultsScroll() {
    var viewportOffset = $parent.scrollTop();
    var viewportHeight = $parent.innerHeight();
    var bottomOfViewport = viewportOffset + viewportHeight;

    var listIntersection = bottomOfViewport - listTop;

    // Can scroll before or after list, keep within 0 <= X <= 1
    var listScrollRatio = Math.min(1, Math.max(0, listIntersection / listHeight));

    var lastVisibleIndex = Math.floor(listScrollRatio * itemCount);

    var visibleRids = OTSearchData.Results.RestaurantIds.slice(0, lastVisibleIndex);

    if (ridsSeenThisPageView.length < visibleRids.length) {
      ridsSeenThisPageView = visibleRids;
    }
  }

  /**
   * Called at beginning of every page render (e.g. initial, change filters, paginate)
   */
  function logRequest() {
    var model = OTSearchData;
    var page = Math.ceil(model.Request.Offset / model.Request.Size);
    var macroIdInt = parseInt(model.Request.RegionIds);
    var QueryCenter = model.Results.QueryCenter;

    // README: For information on log payload:
    // https://wiki.otcorp.opentable.com/display/CP/Payloads+-+search_results
    analytics.page('search_results', {
      cuisines:                 model.Request.ParsedCuisineIds || [],
      datetime:                 model.Request.DateTime,
      distance:                 QueryCenter ? QueryCenter.distance : undefined,
      latitude:                 0,
      longitude:                0,
      location_latitude:        QueryCenter ? QueryCenter.latitude : undefined,
      location_longitude:       QueryCenter ? QueryCenter.longitude : undefined,
      location_query:           '',
      location_query_type:      'opentable_location',
      macro_id:                 macroIdInt || macroIdInt === 0 ? macroIdInt : null,
      metro_id:                 model.Request.MetroId || null,
      minutes_to_search_time:   0,
      neighborhoods:            model.Request.ParsedNeighborhoodIds || [],
      offers:                   model.Request.ParsedOfferTypeIds || [],
      page:                     page,
      party_size:               model.Request.Covers,
      pop:                      model.Request.OnlyPopTimes,
      price_bands:              model.Request.ParsedPriceBandIds || [],
      query:                    model.Request.SearchQuery || '',
      query_type:               'none',
      request_id:               getRequestId(),
      rids:                     model.Results.RestaurantIds,
      sort:                     model.Request.MetaData ? model.Request.MetaData.PersonalizerSort : null,
      user_initiated:           true
    });
  }

  /**
   * Called after teardown (before next) of a page render (e.g. exit page, filters, paginate)
   * Needs to be called later as we need to track viewed RIDs
   */
  function logViewport(isAsync) {
    if (!ridsSeenThisPageView.length) {
      return;
    }

    var events = [];

    // Viewport event required by DS
    events.push({name: 'viewport', properties: {
      request_id: getRequestId(),
      rids: ridsSeenThisPageView
    }});

    // Campaign Rids required by PI
    var campaigns = getCampaignsSeen();
    if (campaigns.length) {
      events.push({name: 'pi_impression_v1', properties: {
        promoted_restaurants: campaigns
      }});
    }

    analyticsTrackMultiple(events, isAsync);

    ridsSeenThisPageView = []; // Clear RIDS after being sent, e.g. paginating, get fresh list
  }

  function getViewedPromotedRids() {
    var promotedRids = OT.Search.Data.get().Results.PromotedRids || {};

    var viewedPromotedRids = _.filter(ridsSeenThisPageView, function(rid) {
      return promotedRids[rid];
    });

    return viewedPromotedRids;
  }

  /**
   * Looks through list of seen rids, cross referencing with campaigns, returning the combination
   *
   * Returns an array of objects for PI, formatted as [{campaign_id:"1",rid:"2"}]
   */
  function getCampaignsSeen() {
    var campaignIds = OT.Search.Data.get().Results.CampaignIds;
    var promotedRids = getViewedPromotedRids();
        
    var campaigns = [];

    if (campaignIds) {
      for (var i = 0; i < promotedRids.length; i++) {
        var rid = promotedRids[i];
        var cid = campaignIds[rid];
        if (cid) {
          campaigns.push({
            rid: String(rid),
            campaign_id: String(cid)
          });
        }
      }
    }

    return campaigns;
  }

  /**
   * Called when a restaurant is clicked (either name or timeslot)
   */
  function logRestaurantVisit(rid, timeslot) {
    analyticsTrackSingle('view_restaurant', {
      request_id: getRequestId(),
      rid: Math.floor(rid),
      timeslot: timeslot || null, // If null, restaurant was visited directly, not via timeslot click, HH:MM
      request_timeslot: OTSearchData.Request.DateTime || null // Center timeslot, e.g. query time, HH:MM
    }, false);
  }

  function getRequestId() {
    var requestIdEl = document.getElementsByClassName('global-footer-system-info')[0];
    var requestIdMatch = requestIdEl ? requestIdEl.innerText.match(/\(Request ID:(.*)\)/) : null;
    return requestIdMatch ? requestIdMatch[1] : '';
  }

  return {
    getRequestId: getRequestId,
    logRequest: logRequest,
    logRestaurantVisit: logRestaurantVisit,
    logViewport: logViewport, // Not needed externally, helps debug
    onRestaurantListChange: onRestaurantListChange // Needs to be called externally when list renders
  };

  /**
   * Translates the website hostname to the analytics collector hostname
   *
   * www.opentable.com -> ac.opentable.com
   * www.opentable.ie -> ac.opentable.ie
   *
   * @param {string} hostname probably location.hostname
   */
  function getAnalyticsHostname(hostname) {
    if (hostname.indexOf('www.opentable.') !== -1) {
      return hostname.replace('www', 'ac');
    }

    return 'ac.opentable.com'; // Default to .com if we're unsure
  }

  /**
   * This is an alternative to analytics.track()
   *
   * @param {string} name
   * @param {Object} properties
   */
  function analyticsTrackSingle(name, properties, isAsync) {
    var payload = getEventBody(name, properties);

    post(
      "https://" + getAnalyticsHostname(location.hostname) + "/v1/t",
      getEventBody(name, properties),
      isAsync
    );
  }

  /**
   * Sends multiple analytics track events at the same time.
   * Required if sending two events when page is tearing down and performing non async request
   *
   * @see https://wiki.otcorp.opentable.com/display/CP/Analytics+Events+and+Collector
   * @param {array} events An array of events with .name and .properties attributes
   * @param {boolean} Whether call is asynchronous, default true
   */
  function analyticsTrackMultiple(events, isAsync) {
    var payload = {
      batch: []
    };

    for (var i = 0; i < events.length; i++) {
      var event = events[i];
      payload.batch.push(getEventBody(event.name, event.properties));
    }

    post(
      "https://" + getAnalyticsHostname(location.hostname) + "/v1/import",
      payload,
      isAsync
    );
  }

  /**
   * Posts a JSON payload to the specified URL
   *
   * @param {string} url
   * @param {boolean} isAsync
   * @param {Object} payload
   */
  function post(url, payload, isAsync) {
    isAsync = typeof isAsync !== 'undefined' ? !!isAsync : true; // default true

    payload = JSON.stringify(payload);

    var request = new XMLHttpRequest();
    request.open('POST', url, isAsync);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(payload);
  }

  /**
   * Takes an event name and properties object and returns an event object
   *
   * @param {string} name The name of the event
   * @param {Object} properties Event properties
   */
  function getEventBody(name, properties) {
    return {
      properties: properties,
      messageId: OT.Common.Helpers.generateGUID(),
      integrations: {},
      event: name,
      timestamp: (new Date()).toISOString(),
      type: 'track',
      anonymousId: OT.Common.Cookies.get('otuvid'),
      userId: String(OT.Common.Cookies.get('uCke').gid || 0),
      context: {
        library: {
          name: 'search-result-node',
          version: '1.0.0'
        },
        page: {
          path: location.pathname,
          referrer: document.referrer,
          search: location.search,
          title: document.title,
          url: location.href
        },
        userAgent: navigator.userAgent,
        device: {
          device: 'desktop'
        }
      }
    };
  }
})();
